/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteContextResourceProjectTerms
 */
export interface QuoteContextResourceProjectTerms {
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResourceProjectTerms
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResourceProjectTerms
     */
    url: string;
}

/**
 * Check if a given object implements the QuoteContextResourceProjectTerms interface.
 */
export function instanceOfQuoteContextResourceProjectTerms(value: object): value is QuoteContextResourceProjectTerms {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function QuoteContextResourceProjectTermsFromJSON(json: any): QuoteContextResourceProjectTerms {
    return QuoteContextResourceProjectTermsFromJSONTyped(json, false);
}

export function QuoteContextResourceProjectTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteContextResourceProjectTerms {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
    };
}

export function QuoteContextResourceProjectTermsToJSON(value?: QuoteContextResourceProjectTerms | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
    };
}

